import { NavLink, Outlet } from "react-router-dom";

const tabs = [
  {
    label: "General Requirements",
    route: "general",
  },
  {
    label: "Partner Company's Requirements",
    route: "partner",
  },
];

const RequirementsLayout = () => {
  return (
    <div className="flex flex-col bg-white rounded-md flex-1 px-6 py-8 gap-4 min-h-0">
      {/* Tabs container */}
      <div className="flex items-center gap-8 border-b pb-2.5">
        {tabs?.map((tab) => {
          return (
            <NavLink
              key={tab?.route}
              to={tab?.route}
              className={({ isActive }) =>
                `font-medium text-xs border-b-2 ${
                  isActive
                    ? "text-charcoal border-primary"
                    : "text-light-black border-transparent"
                }`
              }
            >
              {tab?.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet />
    </div>
  );
};

export default RequirementsLayout;
